import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="header-wrapper">
      <div className="header-container">
        <div className="image">
          {window.innerWidth > 768 ? (
            <img
              src={process.env.PUBLIC_URL + "/images/header.png"}
              alt="Header"
              className="image"
            />
          ) : (
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Header_with logo_mobile@2x.png"
              }
              alt="Header"
              className="mobile-image"
            />
          )}
        </div>
        {window.innerWidth > 768 && <div className="color"></div>}

        {window.innerWidth > 768 && (
          <div className="text">
            <div className="back-container">
              <a href="https://application.axisbank.co.in/webforms/axis-support/index.aspx">
                BACK TO HOME PAGE
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
